module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/hero-title-img@2x.6252527.png";